var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { absolute: "", width: "unset" },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    attrs: {
                      disabled: _vm.loading,
                      block: _vm.$vuetify.breakpoint.xsOnly,
                      color: _vm.error ? "error" : null,
                    },
                  },
                  on
                ),
                [
                  _vm.loading
                    ? [
                        _c("v-icon", [_vm._v(_vm._s(_vm.$MDI.ProgressWrench))]),
                        _vm._v(" \n            "),
                      ]
                    : _vm._e(),
                  _vm._v("\n            Load accession\n        "),
                ],
                2
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm._v(" "),
      _c("v-card", [
        _c(
          "form",
          {
            on: {
              submit: function ($event) {
                $event.preventDefault()
                return _vm.loadSelected.apply(null, arguments)
              },
            },
          },
          [
            _c("v-card-title", [
              _c("div", { staticClass: "text-h5" }, [_vm._v("Load accession")]),
            ]),
            _vm._v(" "),
            _c(
              "v-card-text",
              [
                _c("v-select", {
                  attrs: { items: _vm.sources, label: "Source" },
                  model: {
                    value: _vm.source,
                    callback: function ($$v) {
                      _vm.source = $$v
                    },
                    expression: "source",
                  },
                }),
                _vm._v(" "),
                _vm.source == "QBioLip"
                  ? [
                      _c("v-text-field", {
                        ref: "accession",
                        attrs: { label: "PDB ID" },
                        on: {
                          keydown: function ($event) {
                            _vm.error = false
                          },
                        },
                        model: {
                          value: _vm.accession,
                          callback: function ($$v) {
                            _vm.accession = $$v
                          },
                          expression: "accession",
                        },
                      }),
                      _vm._v(" "),
                      _vm.results !== null && _vm.results.length === 0
                        ? _c(
                            "div",
                            { staticClass: "text-center my-4 grey--text" },
                            [
                              _vm._v(
                                "\n                    No binding sites found for this PDB ID.\n                "
                              ),
                            ]
                          )
                        : _vm.results && _vm.results.length > 0
                        ? _c(
                            "v-list",
                            {
                              staticClass: "qbiolip-result-list",
                              attrs: { dense: "" },
                            },
                            [
                              _c("v-subheader", [
                                _vm._v(
                                  "Select a binding site to load its structure and motif"
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.results, function (item, i) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: i,
                                    staticClass: "qbiolip-motif-item",
                                    attrs: { disabled: _vm.loading },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectResult(item)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          [
                                            _c("strong", [_vm._v("Ligand:")]),
                                            _vm._v(
                                              " " +
                                                _vm._s(item.Ligand.ligname) +
                                                "\n                                "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "grey--text" },
                                              [
                                                _vm._v(
                                                  "(" +
                                                    _vm._s(
                                                      item.Receptor.assembly
                                                    ) +
                                                    ")"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            item.Complex.relvant === "1"
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      "x-small": "",
                                                      color: "success",
                                                      "text-color": "white",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "biologically relevant"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("v-list-item-subtitle", [
                                          _c("strong", [
                                            _vm._v(
                                              "Binding site (" +
                                                _vm._s(
                                                  _vm.bindingResidues(item)
                                                    .length
                                                ) +
                                                "):"
                                            ),
                                          ]),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm
                                                  .bindingResidues(item)
                                                  .join(", ")
                                              ) +
                                              "\n                            "
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  : _c("v-text-field", {
                      ref: "accession",
                      attrs: { label: "Accession" },
                      on: {
                        keydown: function ($event) {
                          _vm.error = false
                        },
                      },
                      model: {
                        value: _vm.accession,
                        callback: function ($$v) {
                          _vm.accession = $$v
                        },
                        expression: "accession",
                      },
                    }),
                _vm._v(" "),
                _vm.error
                  ? _c(
                      "v-sheet",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center",
                          "justify-content": "center",
                        },
                        attrs: {
                          color: "error",
                          rounded: "",
                          width: "100%",
                          height: "48",
                        },
                      },
                      [_vm._v(_vm._s(_vm.error))]
                    )
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { text: "" },
                    nativeOn: {
                      click: function ($event) {
                        _vm.show = false
                      },
                    },
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      type: "submit",
                      color: "primary",
                      text: "",
                      disabled: this.accession.length == 0 || _vm.loading,
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.loadSelected.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.source == "QBioLip" ? "Search" : "Load"))]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }